import React from 'react'
import { Navigate, useLocation } from 'react-router'

import { useUserService } from '../services'

interface PrivateRouteProps {
  component: React.ElementType
  role?: string
  scope: string
  path?: string
  iamServiceUrl?: string
  sessionCookie?: string
  loginPath?: string
  homePath?: string
  [key: string]: unknown
}

const PrivateRoute = ({
  component: Component,
  role,
  scope,
  path: _path,
  iamServiceUrl = window.config?.iam_service_url,
  sessionCookie = window.config?.session_cookie,
  loginPath = '/app/login',
  homePath = '/app/home',
  ...rest
}: PrivateRouteProps) => {
  const { token, isUserInRole } = useUserService(iamServiceUrl, sessionCookie, scope)
  const location = useLocation()

  if (token()) {
    return isUserInRole(role)
      ? <Component {...rest} />
      : <Navigate to={homePath} state={{ from: location }} replace />
  } else {
    return <Navigate to={loginPath} state={{ from: location }} replace />
  }
}

export default PrivateRoute
